import Vue from "vue";
import Vuex from "vuex";
import AuthModule from "./modules/Auth.module";
import UserModule from "./modules/User.module";
import ConfigModule from "./modules/Config.module";
import ClientModule from "./modules/Client.module";
import BranchModule from "./modules/Branch.module";
import OrderModule from "./modules/Order.module";
import ProjectModule from "./modules/Project.module";
import MeasurementModule from "./modules/Measurement.module";
import SurveyorModule from "./modules/Surveyor.module";
import NotificationModule from "./modules/Notification.module";
import OutsideModule from "./modules/OutsideModule";
import CityModule from "./modules/City.module";
import AreaModule from "./modules/Area.module";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    loading: false
  },
  modules: {
    AuthModule,
    UserModule,
    ConfigModule,
    ClientModule,
    BranchModule,
    MeasurementModule,
    OrderModule,
    SurveyorModule,
    ProjectModule,
    OutsideModule,
    CityModule,
    AreaModule,
    NotificationModule
  }
});
export default store;

export const config = function (key, value) {
  store.commit(ConfigModule.types.SET, { key, value });
};
